import validate from "/vercel/path0/node_modules/.pnpm/nuxt@4.4.2_3422d6a04055dad23f81af55cef51739/node_modules/nuxt/dist/pages/runtime/validate.js";
import docs_45version_45global from "/vercel/path0/app/middleware/docs-version.global.ts";
import manifest_45route_45rule from "/vercel/path0/node_modules/.pnpm/nuxt@4.4.2_3422d6a04055dad23f81af55cef51739/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  docs_45version_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/vercel/path0/app/middleware/auth.ts"),
  guest: () => import("/vercel/path0/app/middleware/guest.ts")
}